import { render, staticRenderFns } from "./threeDList.vue?vue&type=template&id=4cd2437d&scoped=true"
import script from "./threeDList.vue?vue&type=script&lang=js"
export * from "./threeDList.vue?vue&type=script&lang=js"
import style0 from "./threeDList.vue?vue&type=style&index=0&id=4cd2437d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd2437d",
  null
  
)

export default component.exports